/*@ngInject*/
const CheckboxGroupController = function ($scope, $controller, $timeout, coreConstant, formViewerConstant, formComponentUtil, coreMediator, formMediator) {
    const splitKey = '::';
    const timeoutList = [];

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}), $controller('baseDataSetFormComponentController', {$scope: $scope}));

    this.$onInit = function () {
        const dataSetImmediateLoad = true;
        const preventDataSetLoadIfConfigurableComponent = false;

        this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(() => {
            this.fieldStructure.layout.groupItemWidth = formComponentUtil.getGroupItemWidth(this.fieldStructure.layout, this.itemsList);
            this.updateItemsWithCheckedValues();
        });

        this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
    };

    this.$onChanges = function () {
        this.onChanges();

        this.updateItemsWithCheckedValues();
    };

    this.getGroupName = function (uiField) {
        return uiField.fieldTemplate.variableName + (this.isRowRepeater() ? ':' + this.fieldStructure.rowNumber : '');
    };

    this.handleChange = function () {
        this.fieldStructure.hasLocalChanges = true;

        this.updateFieldValueFromCheckedItems();

        formComponentUtil.setupFieldProperties(this.fieldStructure, this.formStructure.currencyCode);

        formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
    };

    this.updateItems = function (updateEvent, data) {
        if (this.shouldUpdateItems(updateEvent, data)) {
            timeoutList.push($timeout(() => {
                this.itemsList.length = 0;

                _.each(_.cloneDeep(data.items), (item) => {
                    this.itemsList.push(item);
                });

                this.fieldStructure.layout.groupItemWidth = formComponentUtil.getGroupItemWidth(this.fieldStructure.layout, this.itemsList);
                this.updateItemsWithCheckedValues();
            }, 100));
        }
    };

    this.updateItemsWithCheckedValues = function () {
        const fieldInstance = this.fieldStructure.fieldModel;

        if (fieldInstance) {
            let checkedValues = _.split(fieldInstance.value, splitKey);

            _.forEach(this.itemsList, function (item) {
                item.checked = !!_.includes(checkedValues, item.value);
            });
        }
    };

    this.updateFieldValueFromCheckedItems = function () {
        let fieldValue = '';

        _.forEach(this.itemsList, function (item) {
            if (item.checked) {
                if (fieldValue !== '') {
                    fieldValue += splitKey;
                }
                fieldValue += item.value;
            }
        });

        if (this.fieldStructure.fieldModel) {
            this.fieldStructure.fieldModel.value = fieldValue;
        } else {
            this.fieldStructure.fieldModel = {
                value: fieldValue
            };
        }
    };

    $scope.$on(coreConstant.event.UPDATE_DATA_SET, this.updateItems.bind(this));

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });
};

angular.module('umFormViewer')
    .controller('checkboxGroupController', CheckboxGroupController);
